<template>
  <div>
    <Card>
      <h2 style="text-align: center;margin:20px 0 0 0;">打卡设置</h2>
      <Divider/>
      <div style="width: 70%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="区县" prop="deptIndexCode">
            <Select clearable transfer filterable v-model="formValidate.deptIndexCode">
              <Option v-for="(option, index) in deptList" :value="option.indexCode" :key="index">{{ option.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="签到时间">
            <TimePicker transfer type="time" placeholder="签到开始时间" format="HH:mm" v-model="formValidate.signBeginTime"
                        style="width: 200px"></TimePicker>
            <span> — </span>
            <TimePicker transfer type="time" placeholder="签到结束时间" format="HH:mm" v-model="formValidate.signEndTime"
                        style="width: 200px"></TimePicker>
          </FormItem>
          <FormItem label="签退时间">
            <TimePicker transfer type="time" placeholder="签退开始时间" format="HH:mm" v-model="formValidate.outBeginTime"
                        style="width: 200px"></TimePicker>
            <span> — </span>
            <TimePicker transfer type="time" placeholder="签退结束时间" format="HH:mm" v-model="formValidate.outEndTime"
                        style="width: 200px"></TimePicker>
          </FormItem>
          <FormItem label="设置打卡范围">
            <Button type="primary" @click="setSignRang">打卡范围</Button>
          </FormItem>
          <FormItem label="经度" prop="centerPointLongitude">
            <Input v-model="formValidate.centerPointLongitude"></Input>
          </FormItem>
          <FormItem label="纬度" prop="centerPointLatitude">
            <Input v-model="formValidate.centerPointLatitude"></Input>
          </FormItem>
          <FormItem label="半径（米）" prop="radius">
            <Input v-model="formValidate.radius"></Input>
          </FormItem>
          <FormItem label="地址" prop="address">
            <Input v-model="formValidate.address"></Input>
          </FormItem>
          <div style="text-align: center">
            <Button type="primary" @click="submitHandle" :loading="btnLoading">提交</Button>
            <Button type="default" @click="goBack" style="margin-left: 8px">返回</Button>
          </div>
        </Form>
      </div>
    </Card>

    <Modal
        v-model="mapModal"
        title="设置打卡范围"
        :mask-closable="false"
        :scrollable="false"
        :fullscreen="fullscreen"
        :width="1200"
        :styles="{top: '0px'}"
    >
      <div slot="header" style="text-align:left">
        <span>设置打卡范围</span>
        <Icon v-if="!fullscreen" type="md-expand" color="#999" size="18" @click="setFullScreen"
              style="float:right;margin-right: 25px;margin-top: 1px;"/>
        <Icon v-else type="md-contract" color="#999" size="18" @click="setFullScreen"
              style="float:right;margin-right: 25px;margin-top: 1px;"/>
      </div>
      <div style="position: relative">
        <el-autocomplete
            popper-class="my-autocomplete"
            v-model="keyword"
            :fetch-suggestions="querySearchAsync"
            :trigger-on-focus="false"
            placeholder="请输入地址"
            @select="handleSelect"
            style="width: 300px;position: absolute;top: 5px;left:5px;z-index: 999"
        >
          <template slot-scope="{ item }">
            <div class="name">{{ item.title }}</div>
            <span class="addr">{{ item.address }}</span>
          </template>
        </el-autocomplete>
        <div id="bmap" style="width: 100%;min-height: 550px;"></div>
        <Tag size="large" closable v-if="circleObj !== null"
             @on-close="handleClose">
          中心点经纬度：[{{ circleObj.longitude }},{{ circleObj.latitude }}]，
          半径：{{ circleObj.radius }}m，
          中心点地址：{{ circleObj.address }}
        </Tag>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submitMap">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { BMapLoader } from '@/utils/mapLoader'

export default {
  name: "setRange",
  data() {
    return {
      keyword: '',
      searchList: [],
      loading1: false,
      btnLoading: false,
      fullscreen: false,
      mapModal: false,
      searchLng: '',
      searchLat: '',
      circleRadius: 500,
      inspectorList: [],
      deptList: [],
      centerList: [],
      circle: null,
      marker: null,
      circleObj: null,
      formValidate: {
        deptIndexCode: null,
        signBeginTime: null,
        signEndTime: null,
        outBeginTime: null,
        outEndTime: null,
        centerPointLongitude: null,
        centerPointLatitude: null,
        radius: 0,
        address: ''
      },
      ruleValidate: {
        // departmentId: [
        //   {required: true, message: '必填', trigger: 'blur'}
        // ],
      }
    }
  },
  mounted() {
    this.getDepts()
  },
  methods: {
    // 获取部门
    getDepts() {
      this.$http.get(`/api/getLowerLevelDepts`).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.deptList = res.data
        }
      })
    },
    querySearchAsync(queryString, cb) {
      setTimeout(() => {
        var options = {
          onSearchComplete: function (res) { //检索完成后的回调函数
            var s = [];
            if (local.getStatus() == BMAP_STATUS_SUCCESS) {
              for (var i = 0; i < res.getCurrentNumPois(); i++) {
                s.push(res.getPoi(i));
              }
              cb(s) //获取到数据时，通过回调函数cb返回到<el-autocomplete>组件中进行显示
            } else {
              cb(s)
            }
          }
        }
        var local = new this.BMap.LocalSearch(this.map, options) //创建LocalSearch构造函数
        local.search(queryString) //调用search方法，根据检索词str发起检索
      }, 500);
    },
    handleSelect(item) {
      // console.log(item)
      this.keyword = item.title
      var lat = item.point.lat // 经度
      var lng = item.point.lng // 纬度
      this.searchLng = lng
      this.searchLat = lat
      this.drawCircle(lng, lat)
    },
    setFullScreen() {
      this.fullscreen = !this.fullscreen
    },
    goBack() {
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'signSet'
      })
    },
    //提交
    submitHandle() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          let params = {
            deptIndexCode: this.formValidate.deptIndexCode,
            signBeginTime: this.formValidate.signBeginTime,
            signEndTime: this.formValidate.signEndTime,
            outBeginTime: this.formValidate.outBeginTime,
            outEndTime: this.formValidate.outEndTime,
            centerPointLongitude: this.formValidate.centerPointLongitude,
            centerPointLatitude: this.formValidate.centerPointLatitude,
            radius: this.formValidate.radius,
            centerPointAddress: this.formValidate.address
          }
          console.log(params)
          //保存打卡范围/api/river/range/signRangeConfigs
          this.$http.post(`/api/dutySignConfigs`, params).then(res => {
            // console.log(res)
            if (res.status === 201) {
              this.btnLoading = false
              this.$Message.success('提交成功！')
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'signSet'
              })
            } else {
              this.$Message.error('提交失败！')
            }
          }).catch(res => {
            console.log(res)
          })
        } else {
          this.$Message.error('提交失败！')
        }
      })
    },
    setSignRang() {
      this.mapModal = true
      this.keyword = ''
      if (!this.map) {
        this.initMap()
      }
    },
    handleClose(event, name) {
      this.map.removeOverlay(this.circle);
      this.map.removeOverlay(this.marker);
      this.circleObj = null
    },
    initMap() {
      const _this = this
      BMapLoader(this.$mapSignRangeKey).then(BMap => {
        const map = new BMap.Map('bmap', { enableMapClick: false })
        _this.map = map
        _this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        map.centerAndZoom('德州市', 14)
        _this.map.addEventListener('click', (e) => {
          // console.log(e)
          var lng = e.latlng.lng
          var lat = e.latlng.lat
          _this.drawCircle(lng, lat)
        })
        _this.geoCoder = new BMap.Geocoder()
      })
    },
    // 画圈
    drawCircle(lng, lat) {
      // 判断地图是否有圆形
      if (this.circle) {
        // 清除地图所有圆形跟标记点
        this.map.removeOverlay(this.circle)
        this.map.removeOverlay(this.marker)
      }
      // 圆obj
      var circleObj = {}
      circleObj.radius = this.circleRadius
      circleObj.latitude = lat
      circleObj.longitude = lng

      // 画圆
      var circle = new this.BMap.Circle(new this.BMap.Point(lng, lat), this.circleRadius, {
        strokeColor: '#FF33FF',
        strokeWeight: 2,
        strokeOpacity: 0.5,
        fillOpacity: 0.4,
        strokeStyle: 'dashed',
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: '#1791fc',
        zIndex: 100
      })
      circleObj.circle = circle
      this.circle = circle

      this.marker = new this.BMap.Marker(new this.BMap.Point(lng, lat), {
        // offset: 0
      })
      this.map.addOverlay(this.marker)
      this.map.addOverlay(this.circle)
      this.circle.enableEditing()
      this.mapViewAuto(new this.BMap.Point(lng, lat))

      const _this = this
      this.geoCoder.getLocation(new this.BMap.Point(lng, lat), function (rs) {
        // console.log(rs)
        circleObj.address = rs.address + rs.content.poi_desc
        _this.circleObj = { ...circleObj }
      })
      this.circle.addEventListener('lineupdate', (e) => {
        this.circleRadius = e.target.radius
        const lng = e.target.latLng.lng
        const lat = e.target.latLng.lat
        circleObj.latitude = lat
        circleObj.longitude = lng
        circleObj.radius = e.target.radius
        this.map.removeOverlay(this.marker)
        this.marker = new this.BMap.Marker(new this.BMap.Point(lng, lat), {
          // offset: 0
        })
        this.map.addOverlay(this.marker)
        // this.mapViewAuto(new this.BMap.Point(lng, lat))
        this.geoCoder.getLocation(new this.BMap.Point(lng, lat), function (rs) {
          // console.log(rs)
          circleObj.address = rs.address + rs.content.poi_desc
          _this.circleObj = { ...circleObj }
        })
      })
      // console.log(this.circleObj)
    },
    mapViewAuto(point) {
      const centerPoint = this.map.getViewport([point])
      // 初始化地图，设置中心点坐标和地图级别
      this.map.centerAndZoom(centerPoint.center, 16)
    },
    submitMap() {
      this.mapModal = false
      this.formValidate.centerPointLongitude = this.circleObj.longitude
      this.formValidate.centerPointLatitude = this.circleObj.latitude
      this.formValidate.radius = this.circleRadius
      this.formValidate.address = this.circleObj.address
    }
  }
}
</script>

<style scoped lang="less">
.my-autocomplete {
  li {
    line-height: 20px;
    padding: 5px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>
